import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  switchButtonActive: {
    color: '#bc31a2',
  },
})

export default useStyles
